import QuestionLayout from "./QuestionLayout";

export default function ImageAnswer({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const selected = value.choice;

  function border(choiceValue) {
    if (mode !== "review") {
      return selected === choiceValue
        ? "3px solid #1976d2"
        : "2px solid #ccc";
    }

    const part = feedback?.parts?.choice;

    if (selected === choiceValue) {
      return part?.correct
        ? "3px solid #2e7d32"
        : "3px solid #c62828";
    }

    return "2px solid #ccc";
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 24,
          marginTop: 12
        }}
      >
        {config.choices.map((choice) => (
          <img
            key={choice.value}
            src={choice.image}
            alt=""
            draggable={false}
            width={config.imageWidth ?? 220}
            height={config.imageHeight ?? 140}
            onClick={() => {
              if (mode !== "edit") return;

              onChange({
                choice: choice.value
              });
            }}
            style={{
              cursor: mode === "edit" ? "pointer" : "default",
              border: border(choice.value),
              borderRadius: 8,
              padding: 4,
              background: "#fff",
              userSelect: "none"
            }}
          />
        ))}
      </div>
    </QuestionLayout>
  );
}